import { Suspense } from 'react';

import { Text } from '@spotify-internal/encore-web';
import { ActivityFragment } from '@spotify/confidence-graphql';
import { useTaskRefSuspense } from '@spotify/plugin-confidence-issues-react';

import { getTaskLabelFromActivity } from './taskActivityUtils';

import styles from './TaskActivityContext.module.css';

export type TaskActivityContextProps = {
  activity: ActivityFragment;
};

const TaskActivityLabel = ({ taskName }: { taskName: string }) => {
  const { task } = useTaskRefSuspense({ name: taskName });

  return (
    <Text
      as="p"
      variant="bodySmall"
      semanticColor="textSubdued"
      lineClamp={2}
      className={styles.root}
    >
      {task.displayName}
    </Text>
  );
};

export const TaskActivityContext = ({ activity }: TaskActivityContextProps) => {
  const taskLabel = getTaskLabelFromActivity(activity);

  return (
    <Suspense
      fallback={
        <Text
          as="p"
          variant="bodySmall"
          semanticColor="textSubdued"
          lineClamp={2}
          className={styles.root}
        >
          {taskLabel}
        </Text>
      }
    >
      <TaskActivityLabel taskName={activity.primaryResource} />
    </Suspense>
  );
};
